const doc = [({"da":({"js":({"users":({"notifications":({"partial":({"mark_as_read":"Markér som læst", "mark_all_as_read":"Markér alle som læst"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;